














































import { Component, Prop, VModel } from 'vue-property-decorator'

import {
  GroupedBotProperty,
  PropertyFieldType
} from '../../../../../../../../../../../BotProperties/components/Properties/types'
import { UseFields } from '../../../../../../../../../../../Pi'
import { FieldData } from '../../../../../../../../../../../Pi/types'
import Picker from '../../../../../../../../../../../Picker/Picker.vue'
import { PickerFormat } from '../../../../../../../../../../../Picker/types'
import ConstantValue from '../../../../../logic/PropertyConditionValues/ConstantValue'

enum ConstantValueType {
  String,
  Number,
  Date
}

@Component({
  components: { Picker },
  data() {
    return {
      ConstantValueType,
    }
  }
})
export default class PropertyConstantValueSettings extends UseFields {
  @VModel() conditionValue!: ConstantValue

  @Prop() selectedProperty!: GroupedBotProperty

  get valueType(): ConstantValueType | null {
    switch (this.selectedProperty.type) {
      case PropertyFieldType.String:
      case PropertyFieldType.Email:
      case PropertyFieldType.Phone:
        return ConstantValueType.String
      case PropertyFieldType.Number:
      case PropertyFieldType.Double:
        return ConstantValueType.Number
      case PropertyFieldType.DateTime:
      case PropertyFieldType.Time:
      case PropertyFieldType.Date:
        return ConstantValueType.Date
      default:
        return null
    }
  }

  get timeFormat(): PickerFormat | undefined {
    switch (this.selectedProperty.type) {
      case PropertyFieldType.DateTime:
        return PickerFormat.DateTime
      case PropertyFieldType.Time:
        return PickerFormat.Time
      case PropertyFieldType.Date:
        return PickerFormat.Date
      default:
        return undefined
    }
  }

  get pickerPlaceholder(): string {
    if (this.timeFormat) {
      switch (this.timeFormat) {
        case PickerFormat.Date:
          return this.$t('new_condition_picker_placeholder_date').toString()
        case PickerFormat.Time:
          return this.$t('new_condition_picker_placeholder_time').toString()
        case PickerFormat.DateTime:
          return this.$t('new_condition_picker_placeholder_date_time').toString()
      }
    }
    return ''
  }

  setValue(arg: FieldData): FieldData {
    arg.setter = (val) => this.conditionValue.value = val
    return arg
  }
}
